var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBankBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96804 9.46799L4.88608 10.8139L6.96804 12.1597V9.46799Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0301 21.5203C15.2208 21.4686 14.8324 21.0027 14.8 20.347H15.674C15.6902 20.5713 15.7873 20.7611 16.0462 20.8129V20.0882C15.237 19.9674 14.8809 19.6568 14.8809 18.9494C14.8809 18.3454 15.3341 17.9141 16.0462 17.8623V17.5H16.4185V17.8623C17.0983 17.9141 17.5029 18.2592 17.5514 18.9494H16.7098C16.6775 18.7596 16.6127 18.6215 16.4185 18.5698V19.26C17.1306 19.3635 17.6 19.6223 17.6 20.347C17.6 20.9509 17.2277 21.4686 16.4185 21.5203V21.9H16.0462V21.5203H16.0301ZM16.0301 19.1909V18.5525C15.8197 18.587 15.7064 18.7078 15.7064 18.8803C15.7064 19.0529 15.7711 19.1392 16.0301 19.1909ZM16.3861 20.1572V20.8301C16.5965 20.7784 16.6936 20.6576 16.6936 20.4678C16.7098 20.2952 16.6451 20.209 16.3861 20.1572Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6 7.19995C2.99249 7.19995 2.5 7.69244 2.5 8.29995V21.5C2.5 23.212 3.88792 24.6 5.6 24.6H26.4C28.1121 24.6 29.5 23.212 29.5 21.5V8.29995C29.5 7.69244 29.0075 7.19995 28.4 7.19995H3.6ZM3.9 12.8V8.59995H28.1V12.8H3.9ZM3.9 16.4V21.5C3.9 22.4388 4.66112 23.2 5.6 23.2H26.4C27.3389 23.2 28.1 22.4388 28.1 21.5V16.4H3.9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBankBook);
export default __webpack_public_path__ + "static/media/Icon-bank_book.3102960826d035823c312541cb1b7aca.svg";
export { ForwardRef as ReactComponent };